import SertifikatFormProgram from "components/cms/Sertifikat/SertifikatFormProgram"
import SertifikatFormSkkni from "components/cms/Sertifikat/SertifikatFormSkkni"
import EmployeeDashboardWrapper from "components/layouts/EmployeeDashboardWrapper"
import DefBreadcrumb from "components/ui/breadcrumb/DefBreadcrumb"
import Typography from "components/ui/typography"
import { getCMSSegments } from "utils/helper"

const SertifikatDocumentCreate = () => {
    const segments = getCMSSegments()

    return (
        <EmployeeDashboardWrapper>
            <DefBreadcrumb
                segments={segments}
                prefix="cms"
            />
            <Typography
                variant="subheading4"
                as="h1"
                className="text-primary mt-3 mb-3"
            >
                Buat Sertifikasi Program
            </Typography>

            <SertifikatFormSkkni />
        </EmployeeDashboardWrapper>
    )
}

export default SertifikatDocumentCreate
